<template>
  <div v-shortkey="keyShortcuts" @shortkey="shortKey">
    <el-dialog :visible.sync="showModal" :title="$i18n.t('shortcuts')" width="80%">
      <div class="d-flex justify-content-evenly">
        <el-button
          v-for="(shortcut, index) in userShortcuts"
          :key="`sc-${index}`"
          :data-id="`sc-${index}`"
          type="info"
          @click="press(shortcut.alias)"
          plain
          round
        >
          <span class="material-icons pb-2">{{ shortcut.icon }}</span>
          <div class="fw-bold pb-2">{{ shortcut.name }}</div>
          <div class="d-flex flex-column justify-content-center">
            <small class="mt-2">{{ getShortcut(shortcut.shortCut) }}</small>
          </div>
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import { get } from 'lodash'
import { mapActions } from 'vuex'
import EventBus from '../../utils/event-bus'

Vue.use(require('vue-shortkey'))

/**
 * @class Shortcuts
 *
 * @description This component is used for the shortcut execution
 */
export default {
  name: 'Shortcuts',
  data: () => {
    return {
      guiEditorUrl: `${window.CORE.creatorHost}/gui-editor/update?url=${window.CORE.url}`,
      creatorUrl: window.CORE.creatorHost,
      showModal: false,
      userShortcuts: [],
      keyShortcuts: {},
    }
  },
  async mounted() {
    if (sessionStorage.getItem('shortcuts')) {
      try {
        this.userShortcuts = JSON.parse(sessionStorage.getItem('shortcuts'))
      } catch (error) {
        await this.getShortcuts()
      }
    } else {
      await this.getShortcuts()
    }

    if (this.userShortcuts && Array.isArray(this.userShortcuts)) {
      this.keyShortcuts = this.userShortcuts.reduce((acc, ob) => {
        if (ob.shortCut.length > 1) {
          acc[ob.alias] = ob.shortCut
        }
        return acc
      }, {})
      EventBus.$on('runShortcutCommand', (key) => {
        this.runCommand(key)
      })
    }
  },
  beforeDestroy() {
    EventBus.$off('runShortcutCommand')
  },
  methods: {
    ...mapActions({
      showSearchModal: 'showModal',
      hideSearchModal: 'hideModal',
    }),
    setShortcut(shortcut) {
      const shortCutArray = shortcut.split('+')
      return shortCutArray.map((i) => i.trim())
    },
    getShortcut(shortcut) {
      return shortcut.join(' + ')
    },
    press(srcKey) {
      this.shortKey({ srcKey })
    },
    shortKey(event) {
      this.showModal = false
      this.runCommand(event.srcKey)
    },
    runCommand(key) {
      let usedShortcut = this.userShortcuts.find((s) => s.alias === key)
      if (usedShortcut.actionType === 'redirect') {
        location.href = `${usedShortcut.actionParam}`
      } else if (usedShortcut.actionType === 'click') {
        switch (usedShortcut.actionParam) {
          // Form save shortcut param: form-save
          case 'form-save':
            EventBus.$emit('shortcut-save')
            break
          case 'show-shortcuts':
            this.showModal = true
            break
          case 'gui-editor':
            window.open(this.guiEditorUrl, '_blank')
            break
          case 'creator':
            window.open(this.creatorUrl, '_blank')
            break
          // @todo Itt a további case-ekben lehet lekezelni a további click action typeú shortcutokat
        }
      }
    },
    async getShortcuts() {
      if (get(window, 'CORE.params.ID_S_USER')) {
        const shortcuts = this.$CORE.userShortcuts || []
        this.userShortcuts = shortcuts.map((item) => {
          return {
            name: item.name,
            shortCut: this.setShortcut(item.shortCut),
            alias: item.alias,
            icon: item.icon,
            voiceCommand: item.voiceCommand,
            actionType: item.actionType,
            actionParam: item.actionParam,
            desc: item.desc,
          }
        })
      }
      sessionStorage.setItem('shortcuts', JSON.stringify(this.userShortcuts))
    },
  },
}
</script>
